import React, {useLayoutEffect, useRef} from 'react'
import './comingSoon.less'
import logoUrl from 'url:../../../public/assets/images/logo-nobg.png'
import Icon, {InstagramFilled, InstagramOutlined} from '@ant-design/icons'

export function ComingSoonPage() {
  const animationContainerRef = useRef<HTMLDivElement | null>(null)

  useLayoutEffect(() => {
    let vantaEffect = null
    ;(async () => {
      // const [{default: p5}, {default: vantaTopology}] = await Promise.all([
      //   import('p5'),
      //   import('vanta/src/vanta.topology.js'),
      // ])
      // p5['disableSketchChecker'] = true
      // vantaEffect = vantaTopology({
      //   el: animationContainerRef.current,
      //   p5: p5,
      //   color: '#fff6e7',
      //   backgroundColor: '#317041',
      // })
    })()

    return () => {
      if (vantaEffect) {
        vantaEffect.destroy()
      }
    }
  }, [])

  return (
    <div className="coming-soon">
      <div className="coming-soon__animation-container" ref={animationContainerRef} />
      <div className="coming-soon__info">
        <div className="logo">
          <img src={logoUrl} />
        </div>
        <h1>Coming soon</h1>
        <div className="coming-soon__info__contact">
          Follow us:
          <a href="https://instagram.com/terrasketch.app" target="_blank" rel="noreferer noopener">
            <InstagramFilled />
          </a>
        </div>
      </div>
    </div>
  )
}
